module.exports = __webpack_public_path__ + "static/media/mileage_2_6.3273ffec.png";